/** @typedef {string} AuthTokenLocation */
export const AUTH_TOKEN_LOCATION_HEADER = 'HEADER';
export const AUTH_TOKEN_LOCATION_BODY = 'BODY';
/** @enum {AuthTokenLocation} */
export const AUTH_TOKEN_LOCATION = {
	HEADER: AUTH_TOKEN_LOCATION_HEADER,
	BODY: AUTH_TOKEN_LOCATION_BODY
};